import API_ROUTES from "../constants/api";
import HttpUtil from "../http-handler/http-util";

export default class EmissionFactorService {
  

  static getEmissions({ scope, category, db, period, businessUnitId}) {
    return HttpUtil.get(
      API_ROUTES.EMISSION_FACTOR_LINK.GET_EMISSIONS
      .replace(scope ? "<scope>" : "?scope=<scope>", scope ?? '')
      .replace(category ? "<category>" : "&category=<category>", category ?? '')
      .replace(db ? "<db>" : "&db=<db>", db ?? '')
      .replace(period ? "<period>" : "&period=<period>", period ?? '')
      .replace(businessUnitId ? "<businessUnitId>" : "&businessUnitId=<businessUnitId>", businessUnitId ?? '')
    );
  }

  static getCategories(scope) {
    return HttpUtil.get(
      API_ROUTES.EMISSION_FACTOR_LINK.GET_CATS
      .replace("<scope>", scope )
    );
  }

  static getLevels({ scope, db, category, level, level1, level2, level3, level4, level5 }) {
    return HttpUtil.get(
      API_ROUTES.EMISSION_FACTOR_LINK.GET_LEVELS
      .replace("<db>", db)
      .replace("<scope>", scope)
      .replace(category ? "<category>" : "?category=<category>", category ?? '')
      .replace(level ? "<level>" : "&level=<level>", level ?? '')
      .replace(level1 ? "<level1>" : "&level1=<level1>", level1 ?? '')
      .replace(level2 ? "<level2>" : "&level2=<level2>", level2 ?? '')
      .replace(level3 ? "<level3>" : "&level3=<level3>", level3 ?? '')
      .replace(level4 ? "<level4>" : "&level4=<level4>", level4 ?? '')
      .replace(level5 ? "<level5>" : "&level5=<level5>", level5 ?? '')
    );    
  }

  static getDB() {
    return HttpUtil.get(
      API_ROUTES.EMISSION_FACTOR_LINK.GET_DB

    );
  }

  static linkEmissionFactorDP(dpId, body) {
    return HttpUtil.post(
      API_ROUTES.EMISSION_FACTOR_LINK.LINK_EMI_FACT_DP
      .replace("<metricDataPointId>", dpId), body
    );    
  }

  static linkEmissionFactorMetric(metricId, body) {
    return HttpUtil.post(
      API_ROUTES.EMISSION_FACTOR_LINK.LINK_EMI_FACT_MET
      .replace("<metricId>", metricId), body
    );    
  }

  static getEFLinkingDP(dpId) {
    return HttpUtil.get(
      API_ROUTES.EMISSION_FACTOR_LINK.LINK_EMI_FACT_DP
      .replace("<metricDataPointId>", dpId)
    );    
  }

  static getEFLinkingMetric(dpId) {
    return HttpUtil.get(
      API_ROUTES.EMISSION_FACTOR_LINK.LINK_EMI_FACT_MET
      .replace("<metricId>", dpId)
    );    
  }

  static unlinkEmissionFactorMetric(metricId) {
    return HttpUtil.delete(
      API_ROUTES.EMISSION_FACTOR_LINK.LINK_EMI_FACT_MET
      .replace("<metricId>", metricId)
    );    
  }

  static unlinkEmissionFactorDP(dpId) {
    return HttpUtil.delete(
      API_ROUTES.EMISSION_FACTOR_LINK.LINK_EMI_FACT_DP
      .replace("<metricDataPointId>", dpId)
    );    
  }

  static getEmissionSourcesByVersion({ versionId, scope, db, category }) {
    let url = API_ROUTES.EMISSION_FACTOR_LINK.GET_SOURCES_BY_VERSION
      .replace("<versionId>", versionId)
      .replace("<emissiontable>", db)
      .replace("<scope>", scope)
      .replace(category ? "<category>" : "?category=<category>", category ?? '');
    return HttpUtil.get(url);
  }
}
